import * as echarts from 'echarts/lib/echarts.js'
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { cloneDeep } from 'lodash';
import { Card } from 'antd';

const Wrapper = styled.div`
  width: 600px;
  height: 400px;
`;

const option = {
  // backgroundColor: '#2c343c',
  title: [
    {
      text: 'placeholder',
      textAlign: 'center',
      left: '10%',
      top: '0%',
      textStyle: {
        fontSize: 12,
      },
    },
  ],
  tooltip: {
    trigger: 'item',
  },
  legend: {
    type: 'scroll',
    orient: 'vertical',
    right: 10,
    top: 20,
    bottom: 20,
    data: [],
  },
  series: [
    {
      type: 'pie',
      radius: ['10%', '70%'],
      center: ['25%', '50%'],
      data: [],
      // roseType: "radius",
      label: {
        color: 'rgba(255, 255, 255, 0.3)',
        show: false,
        alignTo: 'edge',
        position: 'outer',
        bleedMargin: 1,
      },
      labelLine: {
        show: false,
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.3)',
        },
        smooth: 0.2,
        length: 10,
        length2: 20,
      },
      emphasis: {
        label: {
          show: false,
        },
      },
      left: 0,
      // right: '50%',
      top: 0,
      bottom: 0,
      animationType: 'scale',
      animationEasing: 'elasticOut',
      animationDelay: () => {
        return Math.random() * 200;
      },
    },
  ],
};

function PieChart({ data, title }) {
  const ele: any = useRef(null);

  useEffect(() => {
    const chart = echarts.init(ele.current);
    const chartOption = cloneDeep(option);
    chartOption.series[0].data = data;
    chartOption.legend.data = data.map( o => o.name);
    chartOption.title[0].text = `Count ${data.length}`;
    chart.setOption(chartOption as any);
  }, [data]);

  return (
    <Card title={title} style={{ width: 650 }}>
      <Wrapper ref={ele} />
    </Card>
  );
}

export default PieChart;
